import type { RoomDef } from '../../sim/types.ts';
import { firstLight } from './01-first-light.ts';
import { rising } from './02-rising.ts';
import { hollow } from './03-hollow.ts';
import { theSeed } from './04-the-seed.ts';
import { patrol } from './05-patrol.ts';
import { cellar } from './06-cellar.ts';
import { pursuit } from './07-pursuit.ts';
import { grovesEnd } from './08-groves-end.ts';

/** The Grove, in play order (brief §6). All eight rooms are authored. */
export const ROOMS: readonly RoomDef[] = [
  firstLight,
  rising,
  hollow,
  theSeed,
  patrol,
  cellar,
  pursuit,
  grovesEnd,
];

export function roomById(id: string): RoomDef {
  const room = ROOMS.find((r) => r.id === id);
  if (!room) throw new Error(`Unknown room: ${id}`);
  return room;
}

export { firstLight, rising, hollow, theSeed, patrol, cellar, pursuit, grovesEnd };
